import clsx from "clsx";
import { useCallback, useMemo, useState } from "react";

import {
  ContactMapCard,
  type LocationMapType,
} from "@widgets/contact-map-card";

import type { TableBlockType } from "@features/article-content/model";

import { Container } from "@shared/ui/container";

import type { MerchType } from "../model";
import { Content } from "./content";
import { Gallery } from "./gallery";

import s from "./merch-page.module.scss";

export type MerchPageProps = {
  merch: MerchType;
  contactMapSection: LocationMapType;
  popupData: {
    tableSize: TableBlockType;
    popup: {
      title: string;
      description: string;
    };
  };
};

export const MerchPage = (props: MerchPageProps) => {
  const { merch, popupData, contactMapSection } = props;

  const [activeVariantIndex, setActiveVariantIndex] = useState(0);

  const currentVariant = useMemo(() => {
    return merch?.merchVariations?.[activeVariantIndex];
  }, [activeVariantIndex]);

  const handleVariantChange = useCallback((id: number) => {
    const currentIdx = merch?.merchVariations.findIndex(
      (variant) => variant.id === id,
    );

    if (currentIdx !== undefined) {
      setActiveVariantIndex(currentIdx);
    }
  }, []);

  return (
    <main className={clsx(s.root)}>
      <section className={s.content}>
        <Gallery data={currentVariant} />
        <Content
          data={merch}
          currentVariant={currentVariant}
          onVariantChange={handleVariantChange}
          popupData={popupData}
        />
      </section>
      {contactMapSection && (
        <Container>
          <ContactMapCard {...contactMapSection} />
        </Container>
      )}
    </main>
  );
};

MerchPage.displayName = "MerchPage";
